// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__MMf3k","imageUploader":"EGiftCard_imageUploader__1O0ON"};